export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return "";

  // mantém só dígitos
  const digits = phone.replace(/\D/g, "");

  if (digits.length === 10) {
    // telefone fixo
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  } else if (digits.length === 11) {
    // celular
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }

  // fallback: retorna o que veio
  return phone;
}
